import type { UpdateTeamDTO } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client";

interface UpdateTeamVariables {
  data: UpdateTeamDTO;
  id: number;
}

export function useUpdateTeam(): UseMutationResult<
  void,
  Error,
  UpdateTeamVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, id }: UpdateTeamVariables) =>
      apiClient.url(`/teams/${id}`).patch(data).res(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: teamsKeys.list,
      });
    },
  });
}
